export const WEBHOOK_EVENT_TYPES = [
    { value: 'collection_arrival', label: 'Collection arrival' },
    { value: 'collected', label: 'Collected' },
    { value: 'partial_collection', label: 'Partial collection' },
    { value: 'delivery_arrival', label: 'Delivery arrival' },
    { value: 'partial_delivery', label: 'Partial delivery' },
    { value: 'delivered', label: 'Delivered' },
]

export const CALLBACK_URL_MAX_LENGTH = 2048

// Quick client-side feedback only; the server performs the authoritative checks.
export const isAllowedCallbackUrl = (value: string) => {
    if (/[?#]/.test(value)) return false

    try {
        const url = new URL(value)

        return (
            url.protocol === 'https:' &&
            (url.port === '' || url.port === '443') &&
            !url.username &&
            !url.password &&
            url.hostname !== 'localhost'
        )
    } catch {
        return false
    }
}
